import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";

const Location = ({ header,image, content }) => {
  return (
    <MainContainer
      dir="column-reverse"
      color={"#EFFDFF"}
      com1={<ImageContainer img={image} />}
      com2={
        <ContentContainer
          Header={<Header content={header} />}
          Content={<ParaData color={"#525560"} fontSize={"16px"} content={content} />}
         />
      }
    />
  );
};

export default Location;
